export default {
      id: "icon--wear-jeans-usage",
      viewBox: "0 0 17 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wear-jeans-usage",
      toString: function () {
        return this.url;
      }
    }